import { Button, Spinner } from '@crm/ui';
import { Plus } from 'lucide-react';
import type { PaginationMeta } from '@/modules/auth/types';

/** Quantos registros cada clique em "Ver mais" acrescenta. */
export const LOAD_MORE_STEP = 10;

interface LoadMoreProps {
  meta?: PaginationMeta;
  /** Nome do que esta na lista, no plural (ex.: "categorias"). */
  label: string;
  loading?: boolean;
  onLoadMore: () => void;
}

/**
 * Fim das listas curtas: em vez de trocar de pagina, o clique pede a proxima e
 * ela entra abaixo do que ja esta na tela - a lista so cresce, sem separar
 * paginas. Quem chama guarda quantos registros pedir (`perPage`).
 */
export function LoadMore({ meta, label, loading = false, onLoadMore }: LoadMoreProps) {
  if (!meta) return null;

  const shown = Math.min(meta.page * meta.perPage, meta.total);
  if (shown >= meta.total) {
    // Sem mais nada para buscar, so o total - some quando a lista e curta.
    return meta.total > LOAD_MORE_STEP ? (
      <p className="pt-2 text-center text-xs text-muted-foreground">
        {meta.total} {label}
      </p>
    ) : null;
  }

  return (
    <div className="flex flex-col items-center gap-1 pt-2">
      {/* Mesmo rotulo da paginacao das listas grandes: no celular a lista
          cresce, nunca troca de pagina. */}
      <Button
        variant="ghost"
        className="w-full text-primary sm:w-auto"
        disabled={loading}
        onClick={onLoadMore}
      >
        {loading ? <Spinner /> : <Plus className="h-4 w-4" />}
        Mostrar mais
      </Button>
    </div>
  );
}
